import make, { Enum } from '@xaamin/enum';

class ComprobanteStatus extends Enum {

  name = 'ComprobanteStatus';

  enum = {
    'valid': 1,
    'cancelling': 10,
    'cancelled': -1,
    'undefined': 999
  }

}

export default make(ComprobanteStatus);